module.exports = __webpack_public_path__ + "img/1532058312.e4e4d51b.jpg";